/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#nuevo_firmante[_ngcontent-%COMP%]{margin-top:25px}.usuario[_ngcontent-%COMP%]{border:1px solid #adadad;border-radius:25px 25px 0 0;padding-top:0;--background:#EEEEEE}.hijos[_ngcontent-%COMP%]{border:1px solid #adadad;padding-top:0}#ultimo_hijo[_ngcontent-%COMP%]{border-radius:0 0 25px 25px}"];
export { styles as styles };
